/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecentHistoryPage } from '../../models/recent-history-page';

export interface UpdateOrCreateIfNotExist$Params {
      body: RecentHistoryPage
}

export function updateOrCreateIfNotExist(http: HttpClient, rootUrl: string, params: UpdateOrCreateIfNotExist$Params, context?: HttpContext): Observable<StrictHttpResponse<RecentHistoryPage>> {
  const rb = new RequestBuilder(rootUrl, updateOrCreateIfNotExist.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecentHistoryPage>;
    })
  );
}

updateOrCreateIfNotExist.PATH = '/recent-history';
